'use client'

import { useModals, useSearchParams } from '@/lib/hooks'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import type React from 'react'
import { use } from 'react'

import { AddCartDiscount } from '@/components/forms/add-cart-discount'
import { RefContext, type Refs } from '@/components/providers/ref-provider'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui'

interface AddCartDiscountModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const AddCartDiscountModal = ({ open }: AddCartDiscountModalProps) => {
  const { closeModal } = useModals()
  const { cartId } = useSearchParams()
  const { barcodeInputRef } = use(RefContext) as Refs

  return (
    <Dialog open={open} onOpenChange={() => barcodeInputRef.current?.focus()}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('ADD_CART_DISCOUNT')}
        size="md"
        className="min-h-[200px]"
      >
        <VisuallyHidden>
          <DialogTitle>Add Cart Discount</DialogTitle>
        </VisuallyHidden>
        {cartId && <AddCartDiscount cartId={cartId} />}
      </DialogContent>
    </Dialog>
  )
}
